import { Building2, Home } from "lucide-react";

/**
 * Photo + name + type + unit-count preview shown right below the community
 * dropdown on the signup form so residents feel confident they've picked the
 * right building before they hit "Create account".
 */
export function CommunityPreviewCard({ community }) {
  if (!community) return null;
  const img = community.hero_image;
  return (
    <div
      className="mt-2 rounded-lg border border-white/10 overflow-hidden bg-white/[0.02]"
      data-testid="reg-community-preview"
    >
      <div className="relative h-32 w-full">
        {img ? (
          <img
            src={img}
            alt={community.name}
            loading="lazy"
            className="h-full w-full object-cover"
            data-testid="reg-community-preview-image"
          />
        ) : (
          <div className="h-full w-full bg-gradient-to-br from-zinc-800 to-zinc-950 flex items-center justify-center">
            <Building2 className="h-8 w-8 text-zinc-600" />
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent" />
        <div className="absolute bottom-2 left-3 right-3">
          <div className="text-white text-sm font-semibold font-display truncate" data-testid="reg-community-preview-name">
            {community.name}
          </div>
          {community.address && (
            <div className="text-[11px] text-zinc-300 truncate">{community.address}</div>
          )}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-2 p-3 text-xs">
        <div className="flex items-center gap-2 text-zinc-300" data-testid="reg-community-preview-type">
          <Home className="h-3.5 w-3.5 text-orange-400" />
          <span className="truncate">{community.type || "Community"}</span>
        </div>
        <div className="flex items-center gap-2 text-zinc-300 justify-end" data-testid="reg-community-preview-units">
          <span className="font-semibold text-white">{community.units || 0}</span>
          <span className="text-zinc-500">units</span>
        </div>
      </div>
    </div>
  );
}
